import {useParams, withRouter} from 'react-router';
import React, {useMemo} from 'react';

import {createForm, renderModalError} from '@utils/forms';
import {SequenceConfigModel} from '@modules/sequenceConfig/forms/SequenceConfigModel';
import SequenceConfigForm from '@modules/sequenceConfig/forms/SequenceConfigForm';
import {RenderBackToListButton} from '@appComponents/ButtonCollection';
import {convertToInt, isUrlParamValid} from '@utils/helpers';
import {showModal} from '@utils/modal';
import {routes} from '@constants/routes';
import HeaderRenderer from '@appComponents/HeaderRenderer';
import {TitleFromQuery} from '@appComponents/TitleFromQuery';
import {GetSequenceTitle} from '@graphql/sequence/query';

const SequenceConfigEdit = () => {
    const {id} = useParams();
    const SequenceConfigEditForm = useMemo(() => (
        createForm(SequenceConfigModel, SequenceConfigForm, {
            id: convertToInt(id),
        })), [id]);

    if (!isUrlParamValid(id)) {
        showModal({
            isVisible: true,
            content: renderModalError('Sequence configuration', routes.sequenceConfigs.index.path),
        });
    }

    return (
        <>
            <HeaderRenderer
                buttons={RenderBackToListButton}
                buttonsProps={{name: 'sequenceConfigs.index'}}
                messagesBoxNames={'sequenceMessageError'}
                pageTitle={
                    <TitleFromQuery
                        query={GetSequenceTitle}
                        variables={{id}}
                        errorBackLink={routes.sequenceConfigs.index.path}
                        path={'sequence.name'}
                        entity={'sequence config'}
                    />
                }
            />
            <SequenceConfigEditForm/>
        </>
    );
};

export default withRouter(SequenceConfigEdit);
